import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { Component, ErrorInfo, ReactNode } from 'react';
import { PageError } from '../extensions/PageError';
import { getAppInsights } from '../TelemetryService';
import { ErrorMessage } from './ErrorMessage';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        getAppInsights().trackException({ exception: error, severityLevel: SeverityLevel.Error })
    }

    render() {
        if (this.state.hasError) {
            const pageError = new PageError('We\'re sorry, something went wrong', {'We\'re sorry': 'Something went wrong'});
            return <ErrorMessage data={pageError} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;